import { FLOWS_BROKER_INFO_MODAL_HELP_BUTTON } from '../../../../flows/src/components/ui/advisory-flow/components/broker-info/BrokerInfoModalContainer';
import useMoveElement from './useMoveElement';

const useMoveHelpButton = (paddingBottom = 0, paddingRight = 0): void => {
  const element = getHelpButtonElement();
  useMoveElement({ element, paddingBottom, paddingRight });
};

export const getHelpButtonElement = (): HTMLElement | null =>
  document.getElementById(FLOWS_BROKER_INFO_MODAL_HELP_BUTTON);

export default useMoveHelpButton;
